import React from 'react';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';

var BlogCategoriesApp = function BlogCategoriesApp(_ref) {
  var settings = _ref.settings;
  var categories = settings.blogCategories;

  var hasCategory = function hasCategory(href) {
    var blogElement = document.querySelector('.component.blog');

    if (!blogElement) {
      return false;
    }

    var currentCategory = blogElement.dataset.category;
    var theCategory;
    var catParamValue = href.split('category=')[1];

    if (catParamValue) {
      theCategory = catParamValue.substring(href.indexOf('&'));
    }

    if (theCategory && decodeURIComponent(theCategory) === currentCategory) {
      return true;
    }

    return false;
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "blog-categories-content-wrapper"
  }, categories.map(function (item, index) {
    var isActive = window.location.href === item.link.href || hasCategory(item.link.href);
    return /*#__PURE__*/React.createElement("div", {
      className: "blog-category ".concat(isActive ? 'active-link' : '', " "),
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link.href,
      dangerouslySetInnerHTML: {
        __html: item.link.content
      }
    }));
  })));
};

export default withReactBootstrap(BlogCategoriesApp);